import { TEMPLATE_TYPES } from "../shared/interfaces/game";

export const getTemplateDesignName = (
  templateType: TEMPLATE_TYPES,
  gameData?: {
    ticketTemplate?: string;
    fan1stTicketTemplate?: string;
    specialSectionTicketTemplate?: string;
    template?: { name?: string };
    fan1stTemplate?: { name?: string };
    specialSectionTemplate?: { name?: string };
  },
): string => {
  if (!gameData) return String(templateType);
  if (templateType === TEMPLATE_TYPES.FAN1st) {
    return gameData.fan1stTemplate?.name || gameData.fan1stTicketTemplate || String(templateType);
  }
  if (templateType === TEMPLATE_TYPES.SPECIAL_SECTION) {
    return gameData.specialSectionTemplate?.name
      || gameData.specialSectionTicketTemplate
      || String(templateType);
  }
  return gameData.template?.name || gameData.ticketTemplate || String(templateType);
};
